<script setup>
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()

// Redirect to the combined reservations page
onMounted(() => {
  router.replace('/reservations-review')
})
</script>

<template>
  <div class="content-wrapper mt-6 text-center">
    <p>Redirecting...</p>
  </div>
</template>

<route lang="yaml">
meta:
  layout: website
  action: read
  subject: AclDemo
  allowLoggedInOnly: true
</route>
